import store from '@/state/store'

const listTableFields = [
  {
    label: 'Nama Vendor',
    key: 'name',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: 'Status',
    key: 'status.name',
  },
  {
    label: 'PIC Vendor',
    key: 'contact_person_name',
    isSortable: true,
  },
  {
    label: 'Total Kontrak',
    key: 'total_contract',
  },
  {
    label: 'Terhubung',
    key: 'is_paired',
    thAttr: {
      style: "text-align: center;"
    },
    tdAttr: {
      style: "text-align: center;"
    },
  },
]

export default listTableFields
